import { RegionTypes } from '../constants/regionType';
import { Logout } from './authService';
import { Regions } from '../config/regions';
import { AppRoutes } from '../constants/appRoutes';

export class RegionService {
	currentRegion() {
		return localStorage.getItem('region');
	}

	verifyRegion(region) {
		return Regions.find((reg) => reg.code === region)?.code || false;
	}

	setRegion(region) {
		if (this.currentRegion() === region) {
			return;
		}
		let regionName = region;
		if (!this.verifyRegion(region)) {
			regionName = this.currentRegion() || RegionTypes.Global;
		}
		Logout();
		localStorage.setItem('region', regionName);
		let newURL = `/${regionName}/${AppRoutes.Login}`;
		window.location.replace(newURL);
	}
}
